import { getClients } from 'api/client'
import { getFarms } from 'api/farm'
import { getHarvestYears } from 'api/harvest'
import { fetchBBox } from 'api/field'
import { dashboardLoaded } from 'actions/app'

export const loadDashboard = () => {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchBBox())
    dispatch(getClients()).then(() => {
      dispatch(getHarvestYears()).then(() => {
        dispatch(getFarms()).then(() => {
          dispatch(dashboardLoaded())
        })
      })
    })
  }
}
